<template>
  <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }" v-loading="loading">
    <div class="dataServiceMonitoring-top">
      <ul class="w-full h-full flex">
        <li @click="$router.push('./api-release?isJumpRequest=true')">
          <div class="top-one w-full text-center">
            <div class="top-tips">
              API发布数
              <el-popover
                content="截至当前累计API发布数量"
                placement="top"
                trigger="hover"
                width="220"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="top-num">{{ totalCount.apiCount || 0 }}</div>
          </div>
        </li>
        <li @click="$router.push('./call-logging?isJumpRequest=true')">
          <div class="top-one w-full text-center">
            <div class="top-tips">
              API调用数
              <el-popover
                content="截至当前累计API调用数量"
                placement="top"
                trigger="hover"
                width="220"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="top-num">{{ totalCount.callApiCount || 0 }}</div>
          </div>
        </li>
        <li @click="$router.push('./call-logging?isJumpRequest=true')">
          <div class="top-one w-full text-center">
            <div class="top-tips">
              API调用次数
              <el-popover
                content="截至当前累计API调用次数"
                placement="top"
                trigger="hover"
                width="220"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="top-num">{{ totalCount.apiCallCount || 0 }}</div>
          </div>
        </li>
        <li @click="$router.push('./call-logging?isJumpRequest=true&isSuccess=true')">
          <div class="top-one w-full text-center">
            <div class="top-tips">
              API调用成功次数
              <el-popover
                content="截至当前累计API调用成功次数"
                placement="top"
                trigger="hover"
                width="220"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="top-num">{{ totalCount.callSuccessCount || 0 }}</div>
          </div>
        </li>
        <li @click="$router.push('./api-application-list')">
          <div class="top-one w-full text-center">
            <div class="top-tips">
              支撑应用数
              <el-popover
                content="截至当前累计（数据服务接口）支撑应用的数量"
                placement="top"
                trigger="hover"
                width="220"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="top-num">{{ totalCount.supportedAppCount || 0 }}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="dataServiceMonitoring-center mt-10px mb-10px">
      <div class="flex day-box border-1 border-color-primary">
        <div
          v-for="(item, index) in dayList"
          :key="index"
          class="day-one border-0 border-r-1 border-solid border-color-primary box-border text-color-system"
          :class="currentDayId === item.id ? 'bg-color-system !text-[#ffffff]' : ''"
          @click="clickDay(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="dataServiceMonitoring-bottom">
      <ul class="flex">
        <li @click="toCallLog(0)">
          <div class="bottom-one">
            <div class="bottom-title h-20px border-l-3 border-color-primary pl-10px">
              API调用Top10
              <el-popover
                :content="`${currentDay}调用次数/成功次数排行Top10`"
                placement="top"
                trigger="hover"
                width="260"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="bottom-content">
              <v-chart
                :options="callApiCountTop10"
                autoresize
                class="w-full h-full"
                ref="callApiCountTop10"
              ></v-chart>
            </div>
          </div>
        </li>
        <li @click="toCallLog(1)">
          <div class="bottom-one">
            <div class="bottom-title h-20px border-l-3 border-color-primary pl-10px">
              API调用平均时长Top10
              <el-popover
                :content="`${currentDay}API调用平均时长排行Top10`"
                placement="top"
                trigger="hover"
                width="250"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="bottom-content">
              <v-chart
                :options="averageCallDurationTop10"
                autoresize
                class="w-full h-full"
                ref="averageCallDurationTop10"
              ></v-chart>
            </div>
          </div>
        </li>
        <li @click="toCallLog(2)">
          <div class="bottom-one">
            <div class="bottom-title h-20px border-l-3 border-color-primary pl-10px">
              API调用失败率Top10
              <el-popover
                :content="`${currentDay}API调用失败率排行Top10`"
                placement="top"
                trigger="hover"
                width="250"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="bottom-content">
              <v-chart
                :options="callApiFailureRateTop10"
                autoresize
                class="w-full h-full"
                ref="callApiFailureRateTop10"
              ></v-chart>
            </div>
          </div>
        </li>
        <li @click="toCallLog(3)">
          <div class="bottom-one">
            <div class="bottom-title h-20px border-l-3 border-color-primary pl-10px">
              API调用趋势分析
              <el-popover
                :content="`${currentDay}API调用次数/成功次数/失败次数趋势`"
                placement="top"
                trigger="hover"
                width="220"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="bottom-content">
              <v-chart
                :options="apiCallTrendAnalysis"
                autoresize
                class="w-full h-full"
                ref="apiCallTrendAnalysis"
              ></v-chart>
            </div>
          </div>
        </li>
        <li @click="toCallLog(4)">
          <div class="bottom-one">
            <div class="bottom-title h-20px border-l-3 border-color-primary pl-10px">
              应用调用Top10
              <el-popover
                :content="`${currentDay}API调用（全部API接口）次数Top10的应用`"
                placement="top"
                trigger="hover"
                width="220"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="bottom-content">
              <div class="app-count flex" v-for="(item, index) in appCallCountTop10" :key="index">
                <div class="app-top">Top{{ index + 1 }}</div>
                <div class="app-name">{{ item.x }}</div>
                <div class="app-num">{{ item.y }}</div>
              </div>
            </div>
          </div>
        </li>
        <li @click="toCallLog(5)">
          <div class="bottom-one">
            <div class="bottom-title h-20px border-l-3 border-color-primary pl-10px">
              API调用失败原因分布
              <el-popover
                :content="`${currentDay}API调用失败原因分布`"
                placement="top"
                trigger="hover"
                width="220"
                ><i class="iconfont icon-line-circleInfo" slot="reference"></i>
              </el-popover>
            </div>
            <div class="bottom-content">
              <v-chart
                :options="callApiErrorReason"
                autoresize
                class="w-full h-full"
                ref="callApiErrorReason"
              ></v-chart>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </el-card>
</template>

<script>
import { OpenApiCallRecordApi } from '@wiz-api/open-api-management'

const openApiCallRecordApi = new OpenApiCallRecordApi()
export default {
  name: 'dataServiceMonitoring',
  data() {
    return {
      dayList: [
        { label: '今日', id: 0 },
        { label: '近7日', id: 1 },
        { label: '本月', id: 2 },
      ],
      currentDay: '今日',
      currentDayId: 0,
      callApiCountTop10: {
        color: ['#5087ec', '#68bbc4'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '100',
          top: '20',
          bottom: '30',
        },
        legend: {
          data: ['调用次数', '调用成功次数'],
          textStyle: {
            color: '#fff',
          },
          show: false,
        },
        xAxis: {
          type: 'value',
          minInterval: 1, // 不允许出现小数位
        },
        yAxis: {
          type: 'category',
          data: [],
        },
        series: [
          {
            name: '调用次数',
            type: 'bar',
            barGap: 0,
            data: [],
          },
          {
            name: '调用成功次数',
            type: 'bar',
            data: [],
          },
        ],
      }, // API调用Top10
      averageCallDurationTop10: {
        color: ['#5087ec', '#68bbc4'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '100',
          top: '20',
          bottom: '30',
        },
        legend: {
          data: ['平均时长(毫秒)'],
          textStyle: {
            color: '#fff',
          },
          show: false,
        },
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          data: [],
        },
        series: [
          {
            name: '平均时长(毫秒)',
            type: 'bar',
            barGap: 0,
            data: [],
          },
        ],
      }, // API平均时长top10
      callApiFailureRateTop10: {
        color: ['#5087ec', '#68bbc4'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '50',
          top: '20',
          bottom: '30',
        },
        legend: {
          data: ['API调用失败率(%)'],
          textStyle: {
            color: '#fff',
          },
          show: false,
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: 'API调用失败率(%)',
            type: 'bar',
            barGap: 0,
            data: [],
          },
        ],
      }, // API调用失败率top10
      callApiErrorReason: {
        color: [
          '#5087ec',
          '#68bbc4',
          '#60b565',
          '#ffcf48',
          '#ff8033',
          '#9a60b4',
          '#3ba272',
          '#73c0de',
          'ee66666',
        ],
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '100',
          top: '20',
          bottom: '30',
        },
        legend: {
          textStyle: {
            color: '#fff',
          },
          show: false,
        },
        series: [
          {
            name: 'API调用失败率(%)',
            type: 'pie',
            radius: '60%',
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    color: '#454545',
                  },
                },
              },
            },
            data: [],
          },
        ],
      }, // API调用失败原因分布
      apiCallTrendAnalysis: {
        color: ['#5087ec', '#68bbc4', '#58a55c'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '100',
          top: '20',
          bottom: '30',
        },
        legend: {
          data: ['API调用次数', 'API调用成功次数', 'API调用失败次数'],
          textStyle: {
            color: '#fff',
          },
          show: false,
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
          minInterval: 1, // 不允许出现小数位
        },
        series: [
          {
            name: 'API调用次数',
            type: 'bar',
            barGap: 0,
            data: [],
          },
          {
            name: 'API调用成功次数',
            type: 'bar',
            barGap: 0,
            data: [],
          },
          {
            name: 'API调用失败次数',
            type: 'line',
            barGap: 0,
            data: [],
          },
        ],
      }, // API调用趋势分析
      appCallCountTop10: [], // 应用调用top10
      totalCount: {},
      loading: false,
    }
  },
  methods: {
    // 跳转调用记录
    toCallLog(type) {
      let data = []
      if (type === 0) {
        // API调用Top10
        data = this.totalCount.callApiCountTop10.total
      } else if (type === 1) {
        // API调用平均时长Top10
        data = this.totalCount.averageCallDurationTop10
      } else if (type === 2) {
        // API调用失败率Top10
        data = this.totalCount.callApiFailureRateTop10
      } else if (type === 3) {
        // API调用趋势分析
        data = this.totalCount.apiCallTrendAnalysis.total
      } else if (type === 4) {
        // 应用调用Top10
        data = this.totalCount.appCallCountTop10
      } else if (type === 5) {
        // API调用失败原因分布
        data = this.totalCount.callApiErrorReason
      }
      const params = []
      _.map(data, (item) => {
        params.push(item.extra)
      })
      localStorage.setItem('callLogParams', JSON.stringify(params))
      this.$router.push(`./call-logging?isJumpRequest=true&jumpRequestType=${type}`)
    },
    clickDay(val) {
      this.currentDayId = val.id
      this.currentDay = val.label
      this.getData()
    },
    async getData() {
      this.loading = true
      const [err, res] = await openApiCallRecordApi.getSummary({ type: this.currentDayId })
      this.loading = false
      if (!err) {
        this.totalCount = res
        // api调用top10
        this.callApiCountTop10.yAxis.data = []
        this.callApiCountTop10.series[0].data = []
        this.callApiCountTop10.series[1].data = []
        if (res.callApiCountTop10) {
          if (res.callApiCountTop10.total.length > 0) {
            _.map(res.callApiCountTop10.total, (item) => {
              this.callApiCountTop10.yAxis.data.push(item.y)
              this.callApiCountTop10.series[0].data.push(item.x)
            })
          }
          if (res.callApiCountTop10.success.length > 0) {
            _.map(res.callApiCountTop10.success, (item) => {
              _.map(this.callApiCountTop10.yAxis.data, (yItem, yIndex) => {
                if (yItem === item.y) {
                  this.callApiCountTop10.series[1].data[yIndex] = item.x
                }
              })
            })
          }
        }
        // API平均时长top10
        this.averageCallDurationTop10.yAxis.data = []
        this.averageCallDurationTop10.series[0].data = []
        if (res.averageCallDurationTop10.length > 0) {
          _.map(res.averageCallDurationTop10, (item) => {
            this.averageCallDurationTop10.yAxis.data.push(item.y)
            this.averageCallDurationTop10.series[0].data.push(item.x)
          })
        }
        // API调用失败率top10
        this.callApiFailureRateTop10.xAxis.data = []
        this.callApiFailureRateTop10.series[0].data = []
        if (res.callApiFailureRateTop10.length > 0) {
          _.map(res.callApiFailureRateTop10, (item) => {
            this.callApiFailureRateTop10.xAxis.data.push(item.x)
            this.callApiFailureRateTop10.series[0].data.push(item.y)
          })
        }
        // API调用失败原因分布
        this.callApiErrorReason.series[0].data = []
        if (res.callApiErrorReason.length > 0) {
          _.map(res.callApiErrorReason, (item) => {
            this.callApiErrorReason.series[0].data.push({ name: item.x, value: item.y })
          })
        }
        // API调用趋势分析
        this.apiCallTrendAnalysis.xAxis.data = []
        this.apiCallTrendAnalysis.series[0].data = []
        this.apiCallTrendAnalysis.series[1].data = []
        this.apiCallTrendAnalysis.series[2].data = []
        if (res.apiCallTrendAnalysis) {
          if (res.apiCallTrendAnalysis.total.length > 0) {
            _.map(res.apiCallTrendAnalysis.total, (item) => {
              this.apiCallTrendAnalysis.xAxis.data.push(item.x)
              this.apiCallTrendAnalysis.series[0].data.push(item.y)
            })
          }
          if (res.apiCallTrendAnalysis.success.length > 0) {
            _.map(res.apiCallTrendAnalysis.success, (item) => {
              this.apiCallTrendAnalysis.series[1].data.push(item.y)
            })
          }
          if (res.apiCallTrendAnalysis.error.length > 0) {
            _.map(res.apiCallTrendAnalysis.error, (item) => {
              this.apiCallTrendAnalysis.series[2].data.push(item.y)
            })
          }
        }
        this.appCallCountTop10 = []
        // 应用调用top10
        if (res.appCallCountTop10.length > 0) {
          this.appCallCountTop10 = res.appCallCountTop10
        }
      }
    },
  },
  created() {
    this.getData()
  },
}
</script>

<style lang="scss" scoped>

.dataServiceMonitoring-top {
  height: 10%;
  ul {
    li {
      width: 18%;
      height: 100%;
      margin-right: 2.5%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #93d2f3;
      background-color: var(--mainBgColor);
      &:last-child {
        margin-right: 0%;
      }
      .top-tips {
        .remark {
          width: 10px;
          height: 10px;
        }
      }
    }
  }
}
.dataServiceMonitoring-center {
  .day-box {
    width: 300px;
    .day-one {
      text-align: center;
      width: 100px;
      color: #57a6fd;
      &:last-child {
        border-right: none;
      }
    }
    .active {
      background: #1684fc;
      color: #fff;
    }
  }
}
.dataServiceMonitoring-bottom {
  height: calc(90% - 46px);
  ul {
    width: 100%;
    height: 100%;
    flex-wrap: wrap;
    li {
      width: 30%;
      height: 50%;
      margin-right: 5%;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .bottom-one {
        width: 100%;
        height: 100%;
        .bottom-title {
          font-weight: 600;
          // padding-left: 20px;
          position: relative;
          margin-bottom: 10px;
          // &::before {
          //   content: '';
          //   width: 5px;
          //   height: 15px;
          //   position: absolute;
          //   top: 5px;
          //   left: 0;
          //   background: #1281f3;
          // }
        }
        .bottom-content {
          height: calc(100% - 34px);
          .app-count {
            background: #4072d7;
            color: #fff;
            border-bottom: 1px solid #fff;
            font-size: 12px;
            height: 10%;
            .app-top {
              width: 15%;
              font-weight: 700;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .app-name {
              width: 50%;
              text-align: center;
              border-left: 1px solid #fff;
              border-right: 1px solid #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .app-num {
              width: 35%;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            &:last-child() {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
}

</style>
